import { useQuery } from '@tanstack/react-query';
import { moodleQueryKeys } from '../all-query-keys';
import { getCourseExclusions } from '../../../services/MoodleService';

export const useGetCourseExclusions = (courseConfigId) => {
  const { data, isLoading, isFetching } = useQuery({
    queryKey: moodleQueryKeys.courseExclusions(courseConfigId),
    queryFn: () => getCourseExclusions(courseConfigId),
    enabled: !!courseConfigId,
  });

  const exclusions = data?.data || [];
  return { exclusions, loading: isLoading || isFetching };
};
